import type { AutocompleteResult, LocationFilter } from "@/lib/api/types";

export function parseLocationResult(result: AutocompleteResult): LocationFilter {
  const category = (result.category as LocationFilter["category"]) ?? "region";
  const parts = result.value.split(", ");
  const geo = result.lat != null && result.lon != null ? { lat: result.lat, lon: result.lon } : {};

  if (category === "country") {
    return { country: result.value, category: "country", display_name: result.value, ...geo };
  }

  if (category === "region") {
    return {
      region: parts[0] ?? result.value,
      country: parts[1],
      category: "region",
      display_name: result.value,
      ...geo,
    };
  }

  return {
    locality: parts[0] ?? result.value,
    region: parts[1],
    country: parts[2],
    category: "city",
    display_name: result.value,
    ...geo,
  };
}
